import { render, staticRenderFns } from "./LiveManagement.vue?vue&type=template&id=29c09970&scoped=true"
import script from "./LiveManagement.vue?vue&type=script&lang=js"
export * from "./LiveManagement.vue?vue&type=script&lang=js"
import style0 from "./LiveManagement.vue?vue&type=style&index=0&id=29c09970&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c09970",
  null
  
)

export default component.exports